import ENV from "../env";

const createPayment = async ({
  amount,
  products,
  customerEmail,
  orgId,
  checkoutUrl,
  isTakeaway = false,
  note = "",
  sellerPaysFees = false,
  tableNumber,
  fromTable,
}) => {
  if (amount === 0 && !isTakeaway) {
    const requestBody = {
      products,
      customerEmail,
      orgId,
      checkoutUrl,
      note,
    };

    if (tableNumber !== undefined) requestBody.tableNumber = tableNumber;
    if (fromTable) requestBody.fromTable = fromTable;

    const response = await fetch(`${ENV.firebaseApiUrl}/orders/free-order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const resData = await response.json();

    if (!response.ok) {
      throw new Error("Paiement échoué: " + resData.message);
    }

    window.location.href = resData.successUrl || `${checkoutUrl}/order/${resData.order.id}/success`;
  } else {
    const requestBody = {
      amount,
      products,
      customerEmail,
      orgId,
      paymentMethods: ["card", "bancontact"],
      checkoutUrl: checkoutUrl,
      isTakeaway: isTakeaway,
      note,
      sellerPaysFees: sellerPaysFees,
    };

    if (tableNumber !== undefined) requestBody.tableNumber = tableNumber;
    if (fromTable) requestBody.fromTable = fromTable;

    const response = await fetch(`${ENV.firebaseApiUrl}/stripe/create-cashless-session`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    });

    const responseText = await response.text();

    let resData;
    try {
      resData = JSON.parse(responseText);
    } catch (e) {
      console.error("Error parsing response:", e);
      throw new Error("Réponse invalide du serveur: " + responseText);
    }

    if (!response.ok) {
      throw new Error("Paiement échoué: " + resData.message);
    }

    const session = resData.session;
    window.open(session.url, "_parent", "noreferrer");
  }
};

export default createPayment;
